var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-50"},[_c('b-form-checkbox-group',{attrs:{"options":_vm.options,"switches":"","stacked":_vm.isMobile},model:{value:(_vm.weekdays),callback:function ($$v) {_vm.weekdays=$$v},expression:"weekdays"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }